/* Amaxa — сторінка Акції: фільтр категорій + додавання в кошик (AJAX). */
(function(){
  var root = document.querySelector('.amxsale');
  if(!root) return;

  var cards = [].slice.call(root.querySelectorAll('.amxsale-card'));
  var boxes = [].slice.call(root.querySelectorAll('.amxsale-side input[type="checkbox"]'));
  var clear = root.querySelector('.amxsale-side .clear');
  var countEl = root.querySelector('.amxsale-count');
  var countTpl = countEl ? countEl.getAttribute('data-tpl') || '{n} товари в акції' : '';

  function apply(){
    var active = boxes.filter(function(b){ return b.checked; }).map(function(b){ return b.value; });
    var visible = 0;
    cards.forEach(function(c){
      var cats = (' ' + (c.dataset.cats || '') + ' ');
      var show = active.length === 0 || active.some(function(a){ return cats.indexOf(' ' + a + ' ') > -1; });
      c.classList.toggle('hidden', !show);
      if(show) visible++;
    });
    if(countEl) countEl.textContent = countTpl.replace('{n}', visible);
  }
  boxes.forEach(function(b){ b.addEventListener('change', apply); });
  if(clear) clear.addEventListener('click', function(){ boxes.forEach(function(b){ b.checked = false; }); apply(); });

  /* Додавання в кошик */
  root.addEventListener('click', function(e){
    var btn = e.target.closest('[data-variant]');
    if(!btn) return;
    e.preventDefault();
    btn.style.opacity = .7;
    fetch('/cart/add.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ id: btn.dataset.variant, quantity: 1 })
    })
    .then(function(r){ return r.json(); })
    .then(function(){
      var b = document.querySelector('.cart-count-bubble span, [data-cart-count]');
      if(b) fetch('/cart.js').then(function(r){return r.json();}).then(function(c){ b.textContent = c.item_count; });
      window.location.href = '/cart';
    })
    .catch(function(){ window.location.href = '/cart'; })
    .finally(function(){ btn.style.opacity = ''; });
  });

  apply();
})();
